// extracted by mini-css-extract-plugin
export default {"container":"M0-z","heading":"N0-z","links":"O0-z","copy":"P0-z","subCopy":"Q0-z","linksLeft":"R0-z","linksCenter":"S0-z","linksRight":"T0-z","link":"U0-z","onlyLink":"V0-z"};